import { Component, Renderer2, DOCUMENT, inject } from '@angular/core';
import {AuthenticationService} from '../../_services/authentication.service';
import { Router, RouterLink } from '@angular/router';
import {TranslateService} from '../../_services/translate.service';
import { MenuItem, PrimeTemplate } from 'primeng/api';
import {headerMenuItems} from '@config/menus/header';
import {MenuAction, TsMenuItem} from '@app/shared/_interfaces/menu';
import {UserService} from '@app/shared/_services/user.service';

import {tawkChats} from '@config/config';
import {StorageService} from '@app/shared/_services/storage.service';
import {Storage} from '@app/shared/_interfaces/storage';
import {environment} from '@environments/environment';
import { Button, ButtonDirective } from 'primeng/button';
import { PopoverModule } from 'primeng/popover';
import { NgClass } from '@angular/common';
import { MenubarModule } from 'primeng/menubar';
import { TranslatePipe } from '../../_pipes/translate.pipe';

@Component({
    selector: 'app-signin-header',
    templateUrl: './app-signin-header.component.html',
    styleUrls: ['./app-signin-header.component.scss'],
    imports: [RouterLink, Button, PopoverModule, PrimeTemplate, ButtonDirective, NgClass, MenubarModule, TranslatePipe]
})
export class AppSigninHeaderComponent {
  private authenticationService = inject(AuthenticationService);
  private router = inject(Router);
  private _translateService = inject(TranslateService);
  private _userService = inject(UserService);
  private _storageService = inject(StorageService);
  private _renderer = inject(Renderer2);
  private _document = inject(DOCUMENT);

  customLogo?: string;
  headerMenuItems: MenuItem[];
  menuActions: MenuAction = {
    'logout': this.logout.bind(this)
  };

  protected isSubaccount: boolean;
  script = this._renderer.createElement('script');

  currentDisplayFont: string;
  currentDisplayTheme: string;

  constructor() {
    this.currentDisplayFont = this._storageService.getFontThemeApp().currentDisplayFont;
    this.currentDisplayTheme = this._storageService.getFontThemeApp().currentDisplayTheme;
    this.setHtmlClass();

    this.isSubaccount = this._userService.getInfoValue('is_subaccount') as boolean;
    this.customLogo = this.isSubaccount && this._userService.getInfoValue('subaccount_config.logo') as string;
    this.headerMenuItems = headerMenuItems
      .filter(menuItem => {
        return !(menuItem?.restriction === 'subaccounts' && this.isSubaccount);
      })
      .map(this.withMenuOperations);

    // tawk.to live-chat widget is NOT loaded on local dev (skips the external embed).
    if (environment.type === 'local') {
      return;
    }

    const lang = this._userService.getInfoValue('lang');
    const tawkParams = lang in tawkChats ? tawkChats[lang] : tawkChats['en'];

    this.script.text = `var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();
    (function () {
      var s1 = document.createElement("script"), s0 = document.getElementsByTagName("script")[0];
      s1.async = true;
      s1.src = 'https://embed.tawk.to/${tawkParams['accountKey']}/${tawkParams['widgetId']}';
      s1.charset = 'UTF-8';
      s1.setAttribute('crossorigin', '*');
      s0.parentNode.insertBefore(s1, s0);
    })();
     Tawk_API.visitor = {
      name  : '${this._userService.getInfoValue('first_name')} ${this._userService.getInfoValue('last_name')}',
      email : '${this._userService.getInfoValue('email')}'
      };
/*
Tawk_API.customStyle = {
  visibility : {
    desktop : {
      xOffset : 980,
      //yOffset : String | Integer,
      //position : 'br', 'bl', 'cr', 'cl', 'tr', 'tl' // Accepted value
    }
  mobile : {
     xOffset : String | Integer,
     yOffset : String | Integer,
     position : 'br', 'bl', 'cr', 'cl', 'tr', 'tl' // Accepted value
   },
   bubble : {
     xOffset : String | Integer,
     yOffset : String | Integer,
     rotate : 90, -90, 0 // Accepted value
 }
}
};*/
    Tawk_API.onLoad = function(){
      document.querySelector('.support-chat a').addEventListener('click', function(){
      Tawk_API.toggle()
      });
    }
    `;
    this._renderer.appendChild(this._document.body, this.script);

  }

  logout() {
    this.authenticationService.logout().subscribe({
      next: (err) => {
        const {message} = err;
        this.router.navigate(['/login'], {
          queryParams: {
            err: message
          }
        });
      }
    });
  }

  private withMenuOperations = (menuItem: TsMenuItem) => {

    let newMenuItem = {...menuItem};

    if (newMenuItem.label) {
      newMenuItem.label = this._translateService.translate(newMenuItem.label);
      if (newMenuItem.id in this.menuActions) {
        newMenuItem.command = this.menuActions[newMenuItem.id];
      }
      if (newMenuItem.id === 'email') {
        newMenuItem.label = this._userService.getInfoValue('email') as string;
      }
      if (newMenuItem.id === 'username') {
        const fullName = `${this._userService.getInfoValue('first_name')} ${this._userService.getInfoValue('last_name')}` as string,
          email = this._userService.getInfoValue('email') as string;

        newMenuItem.label = fullName.length > 0 ? fullName : email;
      }

      if (newMenuItem.replaceUrl) {
        newMenuItem.url = this._translateService.translate(newMenuItem.url);
      }

    }

    if (newMenuItem.restriction === 'subaccounts') {
      newMenuItem.visible = !this.isSubaccount;
    } else if (newMenuItem.restriction === 'already_configured_sender_domains') {
      newMenuItem.visible = !this._userService.getInfoValue('show_gettingstarted_section');
    }

    if (newMenuItem.items) {
      newMenuItem.items = newMenuItem.items.map(this.withMenuOperations);
    }
    return newMenuItem;
  };

  setDisplayFont(display: Storage.DisplayFont) {
    this._storageService.setDisplayFont(display);
    this.currentDisplayFont = display;
    this.setHtmlClass();
  }

  setDisplayTheme(theme: Storage.DisplayTheme) {
    this._storageService.setDisplayTheme(theme);
    this.currentDisplayTheme = theme;
    this.setHtmlClass();
    this._storageService.updateColorTheme(theme);
  }

  setHtmlClass() {
    const currentDisplayFont = this._storageService.getFontThemeApp().currentDisplayFontParse;
    const currentDisplayTheme = this._storageService.getFontThemeApp().currentDisplayTheme;
    let html = document.querySelector('html');
    html?.setAttribute('class', `${currentDisplayTheme} ${currentDisplayFont}`);
  }
}


